export const AvatarSize = 2.5;
